import { useState } from "react";
import { useFetch } from "../lib/useData";
import { PageHero, Section } from "../components/public/PublicLayout";

const HERO = "https://images.unsplash.com/photo-1705723116788-d11fa6e3f415?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const CATS = ["all", "Temple", "Deities", "Festivals", "Seva", "Social Service", "Events"];

export default function Gallery() {
  const [cat, setCat] = useState("all");
  const { data: images } = useFetch(`/public/gallery${cat === "all" ? "" : `?category=${encodeURIComponent(cat)}`}`, [cat]);
  const [lightbox, setLightbox] = useState(null);

  return (
    <div>
      <PageHero title="Gallery" subtitle="Moments of devotion and celebration" image={HERO} />
      <Section>
        <div className="flex flex-wrap gap-2 mb-8" data-testid="gallery-filter">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${cat === c ? "bg-orange-600 text-white" : "bg-amber-100 text-stone-700 hover:bg-amber-200"}`} data-testid={`gallery-cat-${c.replace(/\s/g, "-").toLowerCase()}`}>{c}</button>
          ))}
        </div>
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4" data-testid="gallery-grid">
          {(images || []).map((g) => (
            <button key={g.id} onClick={() => setLightbox(g)} className="block w-full rounded-xl overflow-hidden group" data-testid={`gallery-img-${g.id}`}>
              <img src={g.image} alt={g.alt_text} className="w-full group-hover:scale-105 transition-transform duration-500" loading="lazy" />
            </button>
          ))}
        </div>
      </Section>
      {lightbox && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-6" onClick={() => setLightbox(null)} data-testid="gallery-lightbox">
          <div className="max-w-4xl">
            <img src={lightbox.image} alt={lightbox.alt_text} className="max-h-[80vh] rounded-xl" />
            <p className="text-amber-100 text-center mt-3">{lightbox.caption}</p>
          </div>
        </div>
      )}
    </div>
  );
}
